import React, { useContext } from "react";
import { AuthContext } from "../context/authContext";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
  const { admin } = useContext(AuthContext);
  return admin ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
